export const getUser = ({ initialization: { user } }) => user

export const getSiteKey = state => state.initialization.siteKey
export const getShowGoogleFooterLink = state =>
  state.initialization.showGoogleFooterLink
